import { render, staticRenderFns } from "./Revenuectrl.vue?vue&type=template&id=831fd052&scoped=true&"
import script from "./Revenuectrl.vue?vue&type=script&lang=js&"
export * from "./Revenuectrl.vue?vue&type=script&lang=js&"
import style0 from "./Revenuectrl.vue?vue&type=style&index=0&id=831fd052&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "831fd052",
  null
  
)

export default component.exports